<div class="tw-flex-center tw-w-full search-bar">
  <form class="search-box">
    <input type="search" required />
    <i class="fa fa-search"></i>
  </form>
</div>
